import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SeriesSection = () => {
  const { t } = useTranslation();

  const series = [
    {
      id: 'blue',
      path: '/blue-protect',
      shopPath: '/shop?cat=blue-protect',
      label: 'Blue Protect Serie',
      tagline: t('bp_cultural_title') + ' ' + t('bp_cultural_title2'),
      description:
        'Gebaseerd op een eeuwenoud gebruik van puur indigofera-extract. Beschermt tegen het boze oog, reinigt de aura en bevordert spiritueel welzijn — precies zoals onze voorouders dat deden.',
      highlights: [
        { icon: 'ri-shield-star-line', text: 'Preventieve aura-reiniging' },
        { icon: 'ri-heart-pulse-line', text: 'Veilig voor kinderen & zwangere vrouwen' },
        { icon: 'ri-leaf-line', text: '100% puur indigofera-extract' },
        { icon: 'ri-global-line', text: 'Wereldwijd erkende bescherming' },
      ],
      products: ['Soap', 'Balls', 'Powder', 'Spray'],
      productLabel: 'Soap · Balls · Powder · Spray',
      stats: { reviews: '293+', rating: '4.9', count: '4' },
      image: 'https://public.readdy.ai/ai/img_res/3da61b61a7103369706acc7d718d9043.jpg',
      badge: 'Bestseller Serie',
      badgeBg: 'bg-violet-700/70',
      border: 'border-violet-500/25',
      borderHover: 'hover:border-violet-500/50',
      accentColor: 'text-violet-400',
      accentBg: 'bg-violet-600/15 border-violet-500/20',
      gradientText: 'from-violet-400 to-fuchsia-400',
      ctaBg: 'from-violet-600 to-fuchsia-600',
      overlayFrom: 'from-[#050010]/95',
      overlayVia: 'via-[#050010]/75',
      productThumbBorder: 'border-violet-500/20',
      productImages: [
        'https://readdy.ai/api/search-image?query=luxury%20blue%20protect%20soap%20bar%20deep%20royal%20blue%20mystical%20spiritual%20on%20dark%20background%20blue%20glow&width=100&height=100&seq=bp1&orientation=squarish',
        'https://readdy.ai/api/search-image?query=blue%20protective%20crystal%20balls%20spheres%20spiritual%20cleansing%20deep%20blue%20indigo%20color%20glowing%20dark%20background&width=100&height=100&seq=bp2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=blue%20protective%20powder%20mystical%20spiritual%20cleansing%20in%20dark%20container%20indigo%20shimmer&width=100&height=100&seq=bp3&orientation=squarish',
        'https://readdy.ai/api/search-image?query=blue%20protect%20spray%20bottle%20mystical%20dark%20blue%20aura%20cleansing%20elegant%20glass%20bottle%20indigo%20liquid%20shimmer&width=100&height=100&seq=bp4&orientation=squarish',
      ],
    },
    {
      id: 'evil',
      path: '/evil-energy-destroy',
      shopPath: '/shop?cat=evil-energy-destroy',
      label: 'Evil Energy Destroy Serie',
      tagline: 'Maximale kracht voor zware gevallen',
      description:
        'Opgebouwd rond puur hing-extract (Ferula asafoetida) — het sterkste afwerende middel uit de Surinaamse en Hindoestaanse traditie. 6 producten voor complete bescherming van lichaam en huis.',
      highlights: [
        { icon: 'ri-fire-line', text: 'Puur hing-extract als kerningredient' },
        { icon: 'ri-heart-3-line', text: 'Inclusief Baby Hing Pasta' },
        { icon: 'ri-ancient-pavilion-line', text: 'Hing Poeder als reinigingswierook' },
        { icon: 'ri-sparkling-line', text: 'Spray voor ruimtes zonder vuur' },
      ],
      products: ['Zeep', 'Baby Pasta', 'Hing Poeder', 'Hing Olie', 'Spray', 'Cologne'],
      productLabel: 'Zeep · Baby Pasta · Hing Poeder · Hing Olie · Spray · Cologne',
      stats: { reviews: '336+', rating: '4.9', count: '6' },
      image: 'https://readdy.ai/api/search-image?query=dark%20dramatic%20ancient%20ritual%20crimson%20red%20smoke%20embers%20floating%20mystical%20fire%20energy%20ancient%20protection%20dark%20cave%20obsidian%20black%20background%20glowing%20red%20orange%20ember%20particles%20spiritual%20power%20cinematic%20wide%20atmospheric%20moody&width=800&height=600&seq=hpevil1&orientation=landscape',
      badge: 'Krachtigste Formule',
      badgeBg: 'bg-red-700/70',
      border: 'border-red-500/25',
      borderHover: 'hover:border-red-500/50',
      accentColor: 'text-red-400',
      accentBg: 'bg-red-600/15 border-red-500/20',
      gradientText: 'from-red-400 to-orange-400',
      ctaBg: 'from-red-700 to-orange-700',
      overlayFrom: 'from-[#0d0000]/95',
      overlayVia: 'via-[#0d0000]/75',
      productThumbBorder: 'border-red-500/20',
      productImages: [
        'https://readdy.ai/api/search-image?query=dark%20mystical%20handmade%20protection%20soap%20bar%20deep%20amber%20brown%20hing%20asafoetida%20resin%20spiritual%20evil%20eye%20protection%20soap%20on%20obsidian%20black%20background%20warm%20golden%20glow%20ancient%20ritual%20cleansing%20soap%20premium%20dark%20display&width=100&height=100&seq=eenew1&orientation=squarish',
        'https://readdy.ai/api/search-image?query=gentle%20protective%20baby%20paste%20cream%20jar%20warm%20golden%20amber%20color%20soft%20mystical%20spiritual%20baby%20protection%20paste%20dark%20elegant%20background%20warm%20candlelight%20glow%20ancient%20tradition%20hing%20asafoetida%20baby%20protection%20cream%20premium%20product%20display&width=100&height=100&seq=eenew2&orientation=squarish',
        'https://readdy.ai/api/search-image?query=ancient%20mystical%20hing%20asafoetida%20incense%20powder%20golden%20brown%20powder%20in%20dark%20ceremonial%20container%20smoke%20rising%20spiritual%20cleansing%20incense%20burning%20ritual%20protection%20dark%20stone%20background%20warm%20amber%20glow%20ancient%20apothecary%20premium&width=100&height=100&seq=eenew3&orientation=squarish',
        'https://readdy.ai/api/search-image?query=mystical%20amber%20golden%20hing%20asafoetida%20oil%20in%20dark%20elegant%20glass%20bottle%20oil%20drops%20spiritual%20protection%20candle%20ritual%20oil%20dark%20background%20warm%20golden%20candlelight%20glow%20ancient%20ritual%20oil%20premium%20product%20display%20dark%20stone%20surface&width=100&height=100&seq=eenew4&orientation=squarish',
        'https://readdy.ai/api/search-image?query=dark%20obsidian%20protection%20spray%20bottle%20deep%20red%20amber%20mystical%20glow%20evil%20energy%20shield%20spiritual%20protection%20hing%20spray%20bottle%20dark%20dramatic%20background%20ancient%20power%20premium%20product%20dark%20stone%20display&width=100&height=100&seq=eenew5&orientation=squarish',
        'https://readdy.ai/api/search-image?query=elegant%20dark%20mystical%20cologne%20bottle%20amber%20golden%20hing%20asafoetida%20cologne%20dark%20glass%20bottle%20spiritual%20protection%20ancient%20ritual%20cologne%20dark%20background%20warm%20amber%20glow%20premium%20luxury%20spiritual%20fragrance%20product%20display%20dark%20stone&width=100&height=100&seq=eenew6&orientation=squarish',
      ],
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-[#050010] to-[#080015]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">{t('home_series_badge')}</p>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">
            {t('home_series_title')}{' '}
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
              {t('home_series_title2')}
            </span>
          </h2>
          <p className="text-white/45 text-sm max-w-xl mx-auto leading-relaxed">
            {t('home_series_sub')}
          </p>
        </div>

        {/* Series Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {series.map(s => (
            <div
              key={s.id}
              className={`relative rounded-3xl overflow-hidden border ${s.border} ${s.borderHover} transition-all duration-500 group`}
            >
              {/* Background image */}
              <div className="absolute inset-0">
                <img
                  src={s.image}
                  alt={s.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className={`absolute inset-0 bg-gradient-to-b ${s.overlayFrom} ${s.overlayVia} to-transparent`} />
                <div className={`absolute inset-0 bg-gradient-to-t ${s.overlayFrom} to-transparent`} />
              </div>

              {/* Content */}
              <div className="relative z-10 p-7 lg:p-8 flex flex-col min-h-[500px]">

                {/* Top: badge + stats */}
                <div className="flex items-start justify-between mb-6">
                  <span className={`${s.badgeBg} text-white text-xs font-bold px-3 py-1.5 rounded-full border ${s.border}`}>
                    {s.badge}
                  </span>
                  <div className="flex items-center gap-3">
                    <div className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border ${s.accentBg}`}>
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className={`ri-star-fill ${s.accentColor} text-xs`} />
                      </div>
                      <span className="text-white text-xs font-bold">{s.stats.rating}</span>
                    </div>
                    <span className="text-white/35 text-xs">{s.stats.reviews} {t('home_series_reviews')}</span>
                  </div>
                </div>

                {/* Title */}
                <p className={`${s.accentColor} text-xs font-semibold uppercase tracking-widest mb-2`}>
                  {s.tagline}
                </p>
                <h3 className="text-white font-black text-2xl lg:text-3xl mb-4 leading-tight">
                  <span className={`text-transparent bg-gradient-to-r ${s.gradientText} bg-clip-text`}>
                    {s.label}
                  </span>
                </h3>
                <p className="text-white/55 text-sm leading-relaxed mb-6 max-w-md">
                  {s.description}
                </p>

                {/* Highlights */}
                <div className="grid grid-cols-2 gap-2 mb-7">
                  {s.highlights.map(h => (
                    <div key={h.text} className="flex items-center gap-2">
                      <div className={`w-6 h-6 flex items-center justify-center rounded-lg shrink-0 ${s.accentBg} border`}>
                        <i className={`${h.icon} ${s.accentColor} text-xs`} />
                      </div>
                      <span className="text-white/60 text-xs leading-tight">{h.text}</span>
                    </div>
                  ))}
                </div>

                {/* Product thumbnails */}
                <div className="flex items-center gap-3 mb-8">
                  <div className="flex -space-x-2">
                    {s.productImages.slice(0, 4).map((img, i) => (
                      <div
                        key={i}
                        className={`w-9 h-9 rounded-xl overflow-hidden border-2 ${s.productThumbBorder} shrink-0`}
                        style={{ zIndex: 6 - i }}
                      >
                        <img src={img} alt={s.products[i]} className="w-full h-full object-cover object-top" />
                      </div>
                    ))}
                    {s.productImages.length > 4 && (
                      <div
                        className={`w-9 h-9 rounded-xl border-2 ${s.productThumbBorder} shrink-0 flex items-center justify-center bg-black/60`}
                        style={{ zIndex: 1 }}
                      >
                        <span className={`${s.accentColor} text-xs font-bold`}>+{s.productImages.length - 4}</span>
                      </div>
                    )}
                  </div>
                  <div>
                    <p className="text-white/70 text-xs font-semibold">{s.stats.count} {t('home_series_products')}</p>
                    <p className="text-white/30 text-xs truncate max-w-[180px]">{s.productLabel}</p>
                  </div>
                </div>

                {/* CTAs */}
                <div className="mt-auto flex items-center gap-3">
                  <Link
                    to={s.path}
                    className={`flex-1 flex items-center justify-center gap-2 py-3.5 bg-gradient-to-r ${s.ctaBg} text-white font-bold text-sm rounded-2xl hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-information-line text-sm" />
                    </div>
                    {t('cta_discoverSeries')}
                  </Link>
                  <Link
                    to={`${s.path}#producten`}
                    className={`flex items-center justify-center gap-2 px-5 py-3.5 bg-white/5 border ${s.border} ${s.accentColor} font-semibold text-sm rounded-2xl hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-shopping-cart-line text-sm" />
                    </div>
                    {t('cta_inCart')}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom comparison hint */}
        <div className="mt-10 text-center">
          <p className="text-white/25 text-xs">
            {t('home_series_not_sure')}{' '}
            <Link to="/consultations" className="text-violet-400 hover:text-violet-300 transition-colors cursor-pointer underline underline-offset-2">
              {t('home_series_free_consult')}
            </Link>{' '}
            {t('home_series_help')}
          </p>
        </div>

      </div>
    </section>
  );
};
